module.exports = "/packs/images/products/pods-staged/J1T1810-mobile-5fb214dce4c1006d8d1fc140cd77581a.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/products/pods-staged/J1T1810-mobile.jpg
// module id = 1801
// module chunks = 0